import React from 'react'
import { Link } from 'react-router-dom'

const NoMatch = () => {
  return (
    <div className='w-screen h-screen mx-auto overflow-hidden flex flex-row justify-center items-center'>
        <div className='w-fit text-center mx-auto'>
            <p className='text-3xl text-center font-bold mb-2'>Page Not Found</p>
            <Link to="/" className='text-base text-custom-blue underline cursor-pointer font-medium text-center w-fit mx-auto'>Go Home</Link>
        </div>
    </div>
  )
}

export default NoMatch